module.exports = __webpack_public_path__ + "img/李丽菊.ebbafe45.jpg";